// extracted by mini-css-extract-plugin
export default {"carousel":"LocationSection_carousel__xUVIt","location":"LocationSection_location__uT+s0"};